<div class="tag">
	<ion-chip outline="true" *ngFor="let tag of tags || []">
		<ion-label>{{ (tag.name | dataTranslate:"*").toLowerCase() }}</ion-label>
		<ion-icon *ngIf="canManage" name="close-circle"></ion-icon>
	</ion-chip>
	<ion-button *ngIf="canManage" color="success" shape="round" size="small" (click)="doAdd()">
		<ion-icon name="add"></ion-icon>
	</ion-button>
</div>